module.exports = __webpack_public_path__ + "img/anggaran-rumah-tangga.ae78af75.png";